import * as Yup from 'yup';
export const formValidationSchema = Yup.object({
  formName: Yup.string()
    .max(50, 'Form Name cannot exceed 50 characters')
    .required('Required'),
  formTitle: Yup.string()
    .max(50, 'Form Title cannot exceed 50 characters')
    .required('Required'),
  buttonText: Yup.string()
    .max(30, 'Button text cannot exceed 30 characters')
    .required('Required'),
  textTag: Yup.number()
    .nullable()
    .when('fieldType', {
      is: 1,
      then: (s) => s.required().min(0),
      otherwise: (s) => s.strip(),
    }),
  formDetails: Yup.array()
    .of(
      Yup.object({
        fieldLabel: Yup.string()
          .max(40, 'Field Label cannot exceed 40 characters')
          .required('Required'),
        fieldType: Yup.number().required(),
        placeHolder: Yup.string()
          .max(40, 'Placeholder cannot exceed 40 characters')
          .when('fieldType', {
            is: (val) => [1, 4, 6, 5, 9, 10].includes(val),
            then: (schema) => schema.required('Required'),
          }),
        isMandatory: Yup.boolean(),
        id: Yup.string().notRequired(),
        // fieldMask: Yup.string().when('fieldType', {
        //   is: (val) => [5, 6].includes(val),
        //   then: (schema) => schema.required('Required'),
        // }),
        characterLimit: Yup.number()
          .typeError('Must be a number')
          .positive('Must be a positive number')
          .integer('Must be an integer')
          .when('fieldType', {
            is: (val) => [1, 4, 10].includes(val),
            then: (schema) => schema.required('Required'),
          }),
        showCountryCode: Yup.boolean(),
        showCountryFlag: Yup.boolean(),
        typeSelection: Yup.string().when('fieldType', {
          is: (val) => [9, 10].includes(val),
          then: (schema) =>
            schema
              .required('Required')
              .test(
                'has-valid-types',
                'At least one file type must be selected',
                (value) => {
                  if (!value) return false;
                  const types = value
                    .split(',')
                    .map((v) => v.trim())
                    .filter(Boolean);
                  return types.length > 0;
                }
              ),
        }),
        formsDetailOptions: Yup.array()
          .of(
            Yup.object().shape({
              optionValue: Yup.string().when('$fieldType', {
                is: (val) => [7, 8, 9].includes(val),
                then: (schema) => schema.required('Required'),
              }),
            })
          )
          .when('fieldType', {
            is: (val) => [7, 8, 9].includes(val),
            then: (schema) => schema.min(1, 'At least one option is required'),
          }),
      })
    )
    .min(1, 'At least one form detail is required'),
});
